/**
 * Wrapper for Exception Logging API (Raven)
 */
const logException = (error, options) => {
  const Raven = window?.['Raven'];

  if (Raven) {
    Raven.captureException(error, options);
  }
};

export default logException;
